import { AnimatePresence } from "framer-motion";
import { Routes, useLocation } from "react-router-dom";

interface IRoutesWrapper {
  children: React.ReactNode;
}

const RoutesWrapper = ({ children }: IRoutesWrapper) => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        {children}
      </Routes>
    </AnimatePresence>
  );
};

export default RoutesWrapper;
